import { render, staticRenderFns } from "./GovernmentProcurement.vue?vue&type=template&id=c335b366"
import script from "./GovernmentProcurement.vue?vue&type=script&lang=js"
export * from "./GovernmentProcurement.vue?vue&type=script&lang=js"
import style0 from "./GovernmentProcurement.vue?vue&type=style&index=0&id=c335b366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports